import { render } from "./diningTable.vue?vue&type=template&id=10feae6e"
import script from "./diningTable.vue?vue&type=script&lang=js"
export * from "./diningTable.vue?vue&type=script&lang=js"

import "./diningTable.vue?vue&type=style&index=0&id=10feae6e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__